"use client"
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  alpha,
  Zoom,
  Chip,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import PersonIcon from "@mui/icons-material/Person"
import BusinessIcon from "@mui/icons-material/Business"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PaymentIcon from "@mui/icons-material/Payment"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import StoreIcon from "@mui/icons-material/Store"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import HomeIcon from "@mui/icons-material/Home"
import ReceiptIcon from "@mui/icons-material/Receipt"
import InventoryIcon from "@mui/icons-material/Inventory"
import VerifiedIcon from "@mui/icons-material/Verified"
import EventIcon from "@mui/icons-material/Event"

import { parsearDescripcionFactura } from "../../utils/transaccionDescripcion.js"

const formatCurrency = (value) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
  }).format(value ?? 0)

const formatDate = (value) => {
  if (!value) return "N/A"
  const d = new Date(value)
  return isNaN(d.getTime())
    ? "N/A"
    : new Intl.DateTimeFormat("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(d)
}

const ModalViewTablaFacturaArca = ({
  openModal,
  handleCloseModal,
  selectedTransaccion,
}) => {
  const itemsDesdeJson = parsearDescripcionFactura(selectedTransaccion?.descripcion) || []

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-factura-arca-titulo"
      aria-describedby="modal-factura-arca-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxHeight: "90vh",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper className="modal-container">
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: 2,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ReceiptIcon />
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{ color: "white", borderBottom: "none", m: 0, p: 0 }}
                >
                  Detalles Factura ARCA #{selectedTransaccion?.id}
                </Typography>
                {selectedTransaccion?.tipoFacturaDescripcion && (
                  <Chip
                    label={selectedTransaccion.tipoFacturaDescripcion}
                    size="small"
                    sx={{
                      bgcolor: "rgb(244, 177, 14)",
                      color: "black",
                      fontWeight: "bold",
                      ml: 2,
                    }}
                  />
                )}
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white" }}
                aria-label="cerrar"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ p: 3 }}>
              <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #5b5b5f",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <BusinessIcon sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CalendarTodayIcon fontSize="small" color="action" />
                          <Typography variant="body2">Fecha:</Typography>
                          <Typography variant="body2">
                            {selectedTransaccion?.fechaHoraCreacionDisplay || selectedTransaccion?.createdAt || "N/A"}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <StoreIcon fontSize="small" color="action" />
                          <Typography variant="body2">Negocio:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.negocio || "N/A"}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <AccountCircleIcon fontSize="small" color="action" />
                          <Typography variant="body2">Usuario:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.usuario || "N/A"}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2">Ubicación:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.ubicacion || "N/A"}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Cliente */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid rgb(244, 177, 14)",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PersonIcon sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos del Cliente
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <PersonIcon fontSize="small" color="action" />
                          <Typography variant="body2">Nombre:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {selectedTransaccion?.descripcionEntidad} {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography variant="body2">DNI/CUIT:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.dniCuitCuil || "N/A"}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <HomeIcon fontSize="small" color="action" />
                          <Typography variant="body2">Dirección:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.direccion || "N/A"}</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2">Localidad:</Typography>
                          <Typography variant="body2">{selectedTransaccion?.localidad || "N/A"}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Factura (CAE, vencimiento) */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #2196f3",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <VerifiedIcon sx={{ color: "#2196f3" }} />
                        Datos Factura
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography variant="body2">CAE:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: "monospace" }}>
                            {selectedTransaccion?.CAE || "N/A"}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <EventIcon fontSize="small" color="action" />
                          <Typography variant="body2">Vencimiento CAE:</Typography>
                          <Typography variant="body2">
                            {formatDate(selectedTransaccion?.vencimientoCAE)}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #4CAF50",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <AttachMoneyIcon sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            p: 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                          }}
                        >
                          <AttachMoneyIcon fontSize="small" sx={{ color: "#4CAF50" }} />
                          <Typography variant="body1" fontWeight="bold">
                            Total:
                          </Typography>
                          <Typography variant="body1">
                            {formatCurrency(selectedTransaccion?.montoTotal)}
                          </Typography>
                        </Box>
                        {selectedTransaccion?.pagos?.length > 0 && (
                          <Box sx={{ mt: 1 }}>
                            <Typography variant="body2" sx={{ mb: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}>
                              <PaymentIcon fontSize="small" />
                              Medios de Pago:
                            </Typography>
                            {selectedTransaccion.pagos.map((pago, idx) => (
                              <Box key={idx} sx={{ display: "flex", alignItems: "center", ml: 3, gap: 1 }}>
                                <Typography variant="body2">• {pago.descripcion}:</Typography>
                                <Typography variant="body2">{formatCurrency(pago.monto)}</Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Tabla de Ítems (desde JSON descripcion) */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "#5b5b5f",
                  }}
                >
                  <InventoryIcon />
                  Ítems de la Factura
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={3}
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    maxHeight: 300,
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, bgcolor: "grey.100" }}>
                          Descripción
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 700, bgcolor: "grey.100" }}>
                          Monto
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700, bgcolor: "grey.100" }}>
                          IVA %
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsDesdeJson.length > 0 ? (
                        itemsDesdeJson.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(even)": { bgcolor: "grey.50" },
                              "&:hover": { backgroundColor: alpha("#5b5b5f", 0.05) },
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" fontWeight="medium">
                                {item.descripcion || "-"}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight={600}>
                                {formatCurrency(item.monto)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Chip
                                label={`${item.porcentajeIva ?? 21}%`}
                                size="small"
                                variant="outlined"
                                sx={{ fontWeight: 600 }}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No hay ítems para mostrar
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  )
}

export default ModalViewTablaFacturaArca
